<template>
    <div>
        <MenuPage />
    </div>
    <br><br><br><br>
    <Dialog v-model:visible="isvisible" modal header="Adjunta Evidencia">
        <FileUpload name="demo[]" :custom-upload="true" @uploader="AdjuntarEvidencia($event)" :multiple="false"
            :maxFileSize="100000000">
            <template #empty>
                <span>Arrastra los archivos aqui para subirlos.</span>
            </template>
        </FileUpload>
    </Dialog>
    <div class="contenido">

        <div v-if="spinnervisible === true">
            <div class="metric-card">
                <div style="display: flex; flex-direction: column; gap: 1rem;">
                    <div style="display: flex; align-items: center; gap: 1rem;">
                        <!-- Avatar -->

                        <!-- Información de la orden -->
                        <div style="flex: 1; text-align: left;">
                            <Skeleton width="5rem" class="mb-2"></Skeleton>
                            <Skeleton height="2rem" class="mb-2"></Skeleton>
                            <Skeleton width="5rem" class="mb-2"></Skeleton>
                            <Skeleton width="5rem" class="mb-2"></Skeleton>
                            <Skeleton width="10rem" height="4rem"></Skeleton>
                        </div>

                        <!-- Status -->
                        <div>
                            <Skeleton width="5rem" class="mb-2"></Skeleton>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-for="(item, index) in ordenes" :key="index" v-else>
            <div class="metric-card">
                <div style="display: flex; flex-direction: column; gap: 1rem;">
                    <div style="display: flex; align-items: center; gap: 1rem;">
                        <!-- Avatar -->
                        <div class="avatar">
                            {{ getInitials(item.cliente) }}
                        </div>

                        <!-- Información de la orden -->
                        <div style="flex: 1; text-align: left;">
                            <div class="metric-title">{{ item.No_Orden }}</div>
                            <div style="font-weight: 600; color: #495057;">{{ item.cliente }}</div>
                            <div style="color: #6c757d;">Producto: {{ item.producto }}</div>
                            <div style="color: #6c757d;">Cantidad: {{ item.cantidad }}</div>
                            
                        </div>

                        <!-- Status -->
                        <div>
                            <span :class="item.estatus === 'abierta' ? 'badge badge-success' : 'badge badge-secondary'">
                                {{ item.estatus }}
                            </span>
                        </div>
                    </div>

                    <div v-if="item.tipo === 'servicio'">
                        <!-- Botón iniciar orden -->
                        <div style="text-align: right; margin-top: 1rem;" v-if="item.estatus === 'abierta'">
                            <button class="start-btn" @click="OpenOrder(item)">
                                Iniciar Orden
                            </button>
                        </div>
                        <div style="text-align: right; margin-top: 1rem;" v-if="item.estatus === 'transito'">
                            <button class="success-btn" @click="IngresarInventario(item)">
                                Ingresar a Inventario
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        <!-- Botón iniciar orden -->
                        <div style="text-align: right; margin-top: 1rem;">
                            <button class="start-btn" @click="OpenModal(item)">
                                Cargar Evidencia
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import MenuPage from './MenuPage.vue';
import { ref, onMounted } from 'vue';
import api from '@/plugins/axios';
import { Dialog, FileUpload } from 'primevue';
import Skeleton from 'primevue/skeleton';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';

const spinnervisible = ref(true);
const ordenes = ref(null);
const toast = useToast();
const router = useRouter();
const iditem = ref(0);
const isvisible = ref(false);

const getOrders = async () => {
    try {
        const res = await api.get("/orden/getopen/" + localStorage.getItem("id"));

        setTimeout(() => {
            ordenes.value = [];
            for (let item of res.data) {
                ordenes.value.push({
                    Id: item.Id,
                    No_Orden: item.No_Orden,
                    cantidad: item.Cantidad_Total,
                    estatus: item.status,
                    cliente: item.cliente.razon_social,
                    producto: item.producto.Nombre,
                    notas: item.Notas,
                    tipo: "servicio"
                });
            }
            spinnervisible.value = false;
        }, 2000);

        await getfinishOrders();

    }
    catch (err) {
        console.error(err);
    }
}


const getfinishOrders = async () => {
    const res = await api.get("/orden/getorderclient");
    setTimeout(() => {
        for (let item of res.data) {
            ordenes.value.push({
                Id: item.Id,
                No_Orden: item.No_Orden,
                cantidad: item.cantidad,
                estatus: 'transito',
                cliente: item.cliente,
                producto: item.producto,
                notas: '',
                tipo: "cliente"
            });
        }
    }, 2000);

}


const AdjuntarEvidencia = async (event) => {

    const archivo = event.files[0];
    console.log(iditem.value)
    try {
        let form = new FormData();
        form.append("evidencia", archivo);
        form.append("Id", iditem.value);
        const res = await api.post("/orden/subirevidencia", form);
        console.log(res.data)
        if (res.data.estatus === 'success') {
            isvisible.value= false;
            toast.success("Archivo subido con exito");
            await getOrders();
        }
    }
    catch (err) {
        console.error(err);
    }
}

const OpenModal = (data) =>{
    iditem.value = data.Id;
    console.log(iditem.value)
    isvisible.value = true;
}

const getInitials = (name) => {
    if (!name) return '';
    let words = name.match(/[A-Z][a-z]*|[a-z]+/g) || [];
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
    return words[0].slice(0, 2).toUpperCase();
};

const OpenOrder = (data) => {
    localStorage.setItem("orden", JSON.stringify(data));
    router.push("/ingresar");
}

const IngresarInventario = async (data) => {
    try {
        console.log("id " + data.Id)
        const res = await api.post("/orden/enterinventario", {
            id_orden: data.Id
        });
        console.log(res.data)
        if (res.data.response === 'success') {
            await getOrders();
            toast.success("Orden ingresada en inventario");
        }
    }
    catch (err) {
        console.error(err);
    }
}

onMounted(async () => {
    await getOrders();
});
</script>

<style scoped>
.metric-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
    padding: 25px;
    text-align: center;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    cursor: pointer;
    margin-top: 20px;
}

.metric-card:hover {
    transform: translateY(-6px) scale(1.02);
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
}

.metric-title {
    font-size: 1rem;
    font-weight: 600;
    color: #6c757d;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 6px;
}

/* Avatar */
.avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #0d6efd;
    color: white;
    font-weight: bold;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

/* Badge estilo minimalista */
.badge {
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 600;
    color: white;
}

.badge-success {
    background-color: #28a745;
}

.badge-secondary {
    background-color: #6c757d;
}

/* Botón iniciar orden */
.start-btn {
    background-color: #0d6efd;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.start-btn:hover {
    background-color: #0b5ed7;
}

.success-btn {
    background-color: #0bd771;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.sccess-btn:hover {
    background-color: #004e27;
}

/* Contenedor scrollable */
.contenido {
    width: 80%;
    height: 90vh;
    margin: auto auto auto 19%;
    overflow-y: scroll;
}

@media(max-width:990px) {
    .contenido {
        width: 90%;
        height: 90vh;
        margin: auto;
        overflow-y: scroll;
    }
}
</style>